import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as dayjs from "dayjs";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { OperadoresService } from "../operadores.service";

@Component({
  selector: "app-modal-log-reingreso",
  templateUrl: "./modal.component.html",
})
export class HistorialReingresosModal implements OnInit {
  public defaults?: any = undefined;
  public columns: ListColumn[] = [
    {
      name: "Usuario Ingreso",
      property: "UsuarioIngreso",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Fecha Ingreso",
      property: "FechaIngreso",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Usuario Baja",
      property: "UsuarioBaja",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Fecha Baja",
      property: "FechaBaja",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "Razon",
      property: "RazonBaja",
      visible: true,
      isModelProperty: true,
    },
  ];
  list: any[] = [];

  first = true;

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: OperadoresService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.loadRecords();
  }

  loadRecords() {
    this.service.getHistorialLog(this.data).subscribe(
      (resultData) => {
        let mapped = resultData.map((m) => {
          return {
            ...m,
            FechaBaja: m.FechaBaja
              ? dayjs(m.FechaBaja).format("DD/MM/YYYY")
              : "",
            FechaIngreso: dayjs(m.FechaIngreso).format("DD/MM/YYYY"),
          };
        });
        this.tableComp.setData(mapped);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
